<template>
  <div class="w-full">
    <span v-show="false">{{title}}</span>
    <div class="w-full bg-blue-900/20 rounded-lg p-1 flex gap-1 shadow-sm">
      <button
          class="flex-1 py-2.5 rounded-lg ml-2 text-center text-sm md:text-base font-medium transition-all outline-none "
          :class="active === 'tab1' ? 'text-white bg-amber-500' : 'text-gray-100 bg-white/10'"
          @click="active = 'tab1'"
          role="tab"
          :aria-selected="active === 'tab1'"
      >
        خــارجی
      </button>
      <button
          class="flex-1 py-2.5 rounded-lg mr-2 text-center text-sm md:text-base font-medium transition-all outline-none "
          :class="active === 'tab2' ? 'text-white bg-amber-500' : 'text-gray-100 bg-white/10'"
          @click="active = 'tab2'"
          role="tab"
          :aria-selected="active === 'tab2'"
      >
        ایــرانـی
      </button>
    </div>

    <div class="mt-3 p-1 ">
      <keep-alive>
        <component :is="currentComp"/>
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WaitForDeliver',
  data() {
    return {
      active: 'tab1',
    };
  },

  computed: {
    currentComp() {
      return this.active === 'tab1' ? 'TabChina' : 'TabDomestic';
    },
    title() {
      return this.setDocumentTitle('در انتظار تحویل')
    },

  },
  components: {
    TabChina: () => import('@/modules/delivery/PendingPackage'),
    TabDomestic: () => import('@/modules/delivery/PendingDomesticPackage'),
  },
};
</script>
<style scoped>
</style>
